<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-new-beginning">
<h1>A New Beginning</h1>
<p>That’s how it was with Jimmy, but Michael’s path was very different. That evening over a beer in the picturesque village of Villamayor de Monjardín, he decided to disconnect from Jimmy for a few days. He stated that he didn’t feel like going on in a threesome with Andrés and that he needed to think about some things alone. However, in fact, he wondered whether he should go home, because the whole Camino seemed to him to be some kind of silly game and a load of nonsense, and he did, after all, have to look for a new job and take care of the really important things.</p>
<p>He visited the remains of the castle ‘Castillo de San Esteban de Deyo’, of which only the old sandstone walls and the former <em>aljibe</em> remain, and had a look at the parish church, which the guide praised as a fine example of Romanesque art. Indeed, he decided that the portal there was worth seeing. After a good dinner, he decided to sleep some more to decide what to do next.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?52cc1683